import { Field } from "formik";

export const FormCheck = (props: {
  children: React.ReactNode;
  id: string;
  isInvalid?: boolean;
}) => {
  const { children, id, isInvalid } = props;
  return (
    <div className="form-check form-check--btn">
      <Field
        className={`form-check-input ${isInvalid ? "is-invalid" : ""}`}
        type="checkbox"
        id={id}
        name={id}
      />
      <label className="form-check-label" htmlFor={id}>
        {children}
      </label>
    </div>
  );
};

export const FormCheckList = (props: {
  children: React.ReactNode;
  className?: string;
}) => {
  const { children, className } = props;
  return (
    <div
      className={`d-inline-flex flex-column gap-1${
        className ? ` ${className}` : ""
      }`}
    >
      {children}
    </div>
  );
};
